import defaultStore from '../defaultStore';

const { store } = defaultStore('venusa/order_pending');

store.mutations.setDataToList = (state, payload) => {
  const { data } = payload;

  state.list = data;
};

export default {
  ...store,
};
